<template>
    <div id="pageLoader">
        <div class="lds-ellipsis">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
   
</template>

<script>
    export default {
        name: "Pageloader"
    }
</script>
